
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.763 10.686c-.618-.243-1.389-.322-1.976-.596-.065-.03-.164-.101-.254-.046-.11.069-.17.21-.228.3-.126.196-.233.396-.354.594-.132.215-.32.528-.531.713-.15.13-.297.051-.45.015a19.19 19.19 0 00-1.535-.306c-.138-.021-.616-.197-.739-.071-.277.284-.426.62-.7.907-.181.191-.38.372-.545.572a1.212 1.212 0 01-.213.212c-.123.092-.51-.096-.603-.126-.48-.158-.994-.295-1.457-.474-.194-.074-.279-.183-.429.032-.136.197-.236.403-.374.6-.13.186-.309.36-.461.539-.02.022-.222.328-.265.323-.092-.009-.167-.1-.243-.133a4.096 4.096 0 00-.64-.187c-.223-.052-.478-.123-.725-.123M14.763 7.686c-.7-.377-1.552-.55-2.222-.966-.074-.046-.189-.148-.282-.082-.114.08-.169.26-.223.373-.12.249-.22.503-.335.753-.125.273-.303.67-.518.893-.152.159-.321.041-.492-.02a20.111 20.111 0 00-1.712-.544c-.153-.04-.693-.316-.817-.16-.278.35-.411.78-.685 1.135-.182.236-.385.456-.546.705a1.195 1.195 0 01-.215.261c-.127.11-.569-.173-.673-.221-.541-.253-1.117-.48-1.642-.758-.219-.116-.322-.267-.466.004-.132.248-.223.51-.356.757-.127.234-.307.447-.458.67-.019.027-.213.413-.261.403-.102-.02-.192-.148-.279-.197a4.569 4.569 0 00-.719-.305c-.249-.089-.535-.206-.806-.229","stroke":"#262626","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M4 19H2.643C1.735 19 1 18.105 1 17v-4m2.5 6h9.821c1.179 0 1.643-1 1.643-2v-6M1 10V3c0-1.105.735-2 1.643-2H13.32c.908 0 1.643.895 1.643 2v4.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    